import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useEffect, useMemo, useState } from 'react';
import { textTran } from 'eco-design/elements/eco-email/config';
import moment from 'moment';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

const contactListIds = {
    us: '1272859510',
    ca: '250347439',
    au: '514743487',
};

function BannerEmailB() {
    const { locale = 'us' } = getLocal();
    const { t } = useLang('theProduct.BannerA');
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    const fields = useMemo(() => {
        const date = moment(systemTime).format('YYYY-MM-DD') as any;
        const NA_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: false },
            { type: 'multiple', id: '11150', value: [13], overwrite: false },
            { type: 'text', id: '12555', value: date, overwrite: false },
        ];

        switch (locale) {
            case 'us':
                return [{ type: 'single', id: '4423', value: 1, overwrite: true }, ...NA_Fields];
            case 'ca':
                return [{ type: 'single', id: '4424', value: 1, overwrite: true }, ...NA_Fields];
            case 'au':
                return [
                    { type: 'multiple', id: '9104', value: [22], overwrite: true },
                    { type: 'single', id: '31', value: 1, overwrite: false },
                    { type: 'multiple', id: '11571', value: [10], overwrite: false },
                    { type: 'text', id: '13625', value: date, overwrite: false },
                ];
            default:
                return [{ type: 'single', id: '4423', value: 1, overwrite: true }, ...NA_Fields];
        }
    }, [locale, systemTime]);

    // 邮件
    const termsHtml = useMemo(() => {
        switch (locale) {
            case 'us':
            case 'ca':
                return `I consent to the <a href="https://${locale}.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-${locale}/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.`;
            default:
                return undefined;
        }
    }, [locale]);

    return (
        <div className="email-hot-box">
            {locale !== 'au' && <div className="email-hot-a">{t('discount')}</div>}
            <EcoEmail
                contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.us]}
                source="WEB_NEW_PRODUCT_SUB"
                fields={fields}
                termsHtml={termsHtml}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: textTran[locale]?.btnText ?? textTran['us'].btnText,
                    product_name: 'EcoFlow GLACIER Classic',
                }}
                tipsObj={{
                    placeholder: t('placeholder'),
                    tipsCheck: t('tipsCheck'),
                    successTips: t('successTips'),
                }}
                needTerms
                defaultTermsCheck
                subscribeData={{
                    sector_name: 'EcoFlow GLACIER Classic',
                    entry_position: 1,
                }}
            />
        </div>
    );
}
export default function Comp() {
    const { t: s } = useLang('theProduct.SectionB');
    const { t } = useLang('theProduct.BannerA');
    const { locale = 'us' } = getLocal();

    const USE_EMAIL = ['us', 'ca', 'au'].includes(locale as string);

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc:
            locale === 'au'
                ? 'https://websiteoss.ecoflow.com/upload/image/1755248009779/KV_PC.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1746587872263/kv.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1746587872086/kv-ss.jpg',
        h5:
            locale === 'au'
                ? 'https://websiteoss.ecoflow.com/upload/image/1755248010010/KV_M.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1746587872976/kv-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1746587872434/kv-ss-h5.jpg',
        label: t('label'),
        title: t('title'),
        subTitle: USE_EMAIL ? undefined : t('subTitle'),
        desc: t('desc'),

        lChildren: t('subscribe'),
        lHref: USE_EMAIL ? '' : '#SectionB',
        lType: 'filled',
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'click_anchor',
            button_name: t('subscribe'),
            position: s.rich('title', { h: (v: string) => v }),
        },
        rChildren: t('video'),
        rHref: USE_EMAIL ? '' : 'https://www.youtube.com/embed/SYjOmBQ9PCQ',
        rType: 'outlined',
        rBtnIsYouToBe: true,

        childrenB: USE_EMAIL ? <BannerEmailB /> : undefined,

        theme: 'white',
    };

    const [bannerHeight, setBannerHeight] = useState(800);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const callback = () => {
                const { height = 0 } = document.querySelector('.ecoflow-frame-header')?.getBoundingClientRect() ?? {};
                const { height: navHeight = 0 } = document.querySelector('.eco-nav-product')?.getBoundingClientRect() ?? {};
                // @ts-ignore
                setBannerHeight(window.innerHeight - height - navHeight);
            };
            if (window.innerWidth < 1024) {
                setTimeout(() => {
                    callback();
                }, 0);
            } else {
                callback();
                window.addEventListener('resize', callback);
                return () => window.removeEventListener('resize', callback);
            }
        }
    }, []);
    return (
        <div className={styles.comp} id="Banner" style={{ '--banner-height': bannerHeight + 'px' }}>
            <EcoBanner {...dataA} />
        </div>
    );
}
